export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  SUB_SECTION_PAGE: "sub-section-page",
  COLLECTION_PAGE: "collection-page",
  TAG_PAGE: "tag-page",
  CARTOON_PAGE: "cartoon-page",
  SEARCH_PAGE: "search-page",
  BOOKMARK_PAGE: "bookmark-page",
  STORY_PAGE: "story-page",
  AUTHORS_PAGE: "authors-page",
  AUTHOR_PAGE: "author-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  RESET_PASSWORD_PAGE: "reset-password-page",
  PROFILE_PAGE: "profile-page",
  USER_LOGIN: "user-login",
  VISUAL_STORY: "visual-story",
  HOROSCOPE_PAGE: "horoscope-page",
  INSTAGRAM_PAGE: "instagram-page"
});
export const TAG_PAGE_URL_PREFIX = "/tags/";
export const storyFields =
  "headline,id,subheadline,slug,seo,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata,tags";

export const EPAPER_BANNER_TEXT = Object.freeze({
  HEADLINE: "ಯಾವಾಗಲಾದರೂ ಎಲ್ಲಿಯಾದರೂ", // Keeping for safety if used elsewhere or strict mapping
  SUBHEADLINE: "ಪ್ರಜಾವಾಣಿ ಈ-ಪತ್ರಿಕೆ ನಿಮ್ಮ ಪ್ರತಿ ಮುಂಜಾನೆಯ ಹವ್ಯಾಸವಾಗಲಿ",
  BUTTON_MOBILE: "ಈ ಪತ್ರಿಕೆ",
  BUTTON_DESKTOP: "ಇಂದಿನ ಈ-ಪತ್ರಿಕೆ ಓದಿ",
  PAPER_BANNER_HEADING_1: "ಯಾವಾಗಲಾದರೂ",
  PAPER_BANNER_HEADING_2: "ಎಲ್ಲಿಯಾದರೂ",
  PAPER_BANNER_SUBHEADING: "ಇಂದೇ ಹೆಚ್ಚು ಪರಿಷ್ಕೃತವಾಗಿರುವ ಇ-ಪೇಪರ್ ನ ಅನುಭವ ಪಡೆಯಿರಿ",
  PAPER_BANNER_CTA: "ಇಂದಿನ ಇ-ಪತ್ರಿಕೆ ಓದಿ",
  PAPER_BANNER_FEATURE_1_TITLE: "ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಹುಡುಕಿ",
  PAPER_BANNER_FEATURE_1_SUBTITLE: "ಮತ್ತು ಹಂಚಿಕೊಳ್ಳಿ",
  PAPER_BANNER_FEATURE_2_TITLE: "ಬಳಕೆದಾರ ಸ್ನೇಹಿ",
  PAPER_BANNER_FEATURE_2_SUBTITLE: "ವಿನ್ಯಾಸ",
  PAPER_BANNER_FEATURE_3_TITLE: "ದಾಖಲೆಗಳನ್ನು",
  PAPER_BANNER_FEATURE_3_SUBTITLE: "ಪರಿಶೀಲಿಸಲು ಅನುಮತಿ"
});

export const COMMON_TEXT = Object.freeze({
  NO_RESULTS: "ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಲಭ್ಯವಿಲ್ಲ"
});
